import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const AppIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="8" fill="var(--mode-vector-primary-weakest)" />
      <path
        d="M10.0613 11.168L9.36304 9.18555H6.63354L5.9353 11.168H4.69995L7.3562 4H8.65503L11.3064 11.168H10.0613ZM9.0603 8.17969L8.38159 6.22656C8.35555 6.14193 8.31811 6.02311 8.26929 5.87012C8.22046 5.71387 8.17163 5.55599 8.1228 5.39649C8.07397 5.23373 8.03328 5.09701 8.00073 4.98633C7.96818 5.11979 7.92749 5.26953 7.87866 5.43555C7.83309 5.59831 7.78752 5.7513 7.74194 5.89453C7.69962 6.03776 7.66707 6.14844 7.64429 6.22656L6.96069 8.17969H9.0603Z"
        fill="var(--theme-neutral-1000)"
      />
    </Icon>
  );
};
